import { InputAdornment, InputAdornmentProps, styled } from "@mui/material";

export const FullHeightAdornment = styled(InputAdornment)<InputAdornmentProps>(() => ({
  alignSelf: "stretch",
  maxHeight: "inherit",
  height: "auto",
}));
